export const STUDENT_STATUS = {
    APPLICANT: "APPLICANT",
    STUDENT: "STUDENT",
    RETURNER: "RETURNER",
};
